/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_EyebrowInputs */

const tr_landing_referral_eyebrow = /** @type {(inputs: Landing_Referral_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet Et, Kazan`)
};

const en_landing_referral_eyebrow = /** @type {(inputs: Landing_Referral_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refer & Earn`)
};

const de_landing_referral_eyebrow = /** @type {(inputs: Landing_Referral_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfehlen & Profitieren`)
};

const ru_landing_referral_eyebrow = /** @type {(inputs: Landing_Referral_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашайте и зарабатывайте`)
};

/**
* | output |
* | --- |
* | "Refer & Earn" |
*
* @param {Landing_Referral_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_eyebrow = /** @type {((inputs?: Landing_Referral_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_eyebrow(inputs)
	if (locale === "de") return de_landing_referral_eyebrow(inputs)
	if (locale === "ru") return ru_landing_referral_eyebrow(inputs)
	return tr_landing_referral_eyebrow(inputs)
});